import { createAction } from "typesafe-actions";
export var set = createAction("user/SET", function (resolve) {
  return function (newState) {
    return resolve(newState);
  };
});
export var setToken = createAction("user/SET_ACCESS_TOKEN", function (resolve) {
  return function (accessToken) {
    return resolve(accessToken);
  };
});
export var setQuizState = createAction("user/SET_USER_QUIZ_STATE", function (resolve) {
  return function (userQuizState) {
    return resolve(userQuizState);
  };
});
export var clear = createAction("user/CLEAR");